import react from 'react'



const Department = () =>{


    return(<>
    
     <h1>

     </h1>
    </>)
}
export default Department